import React from 'react';
import { styled } from '@ff/ui';
import Box from '@ff/ui/Box';
import type { Props } from './props-schema';
import SocialIcon from './SocialIcon';
import Text from '@ff/ui/Text';

export default function SimpleFooter(props: Props) {
  const { socialLinks } = props;

  return (
    <Container>
      <Brand>Faraday&Future Inc. © {new Date().getFullYear()}</Brand>
      <SocialContainer>
        {
          socialLinks?.map(item => (
            <IconContainer key={item.icon}>
              <SocialIcon icon={item.icon} url={item.url} />
            </IconContainer>
          ))
        }
      </SocialContainer>
    </Container >
  )
}

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'column-reverse',
  padding: '35px 50px',
  backgroundColor: 'rgba(45, 47, 52, 1)',
  width: '100%',

  [theme.mediaQueries.md]: {
    padding: '35px 146px',
    flexDirection: 'row',
  },
}));


const SocialContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  gap: '30px',
  flexWrap: 'wrap',
  marginBottom: '50px'
});

const IconContainer = styled(Box)(({ theme }) => ({
}));

const Brand = styled(Text)({
  color: 'rgba(255, 255, 255, 0.8)',
  marginBottom: '50px',
  textAlign: 'center'
});
